/**
 * Утилиты для трансформации между camelCase и snake_case
 * Используется для автоматической конвертации данных при обмене с бекендом
 */

/**
 * Преобразует строку из camelCase в snake_case
 */
function camelToSnake(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

/**
 * Преобразует строку из snake_case в camelCase
 */
function snakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

/**
 * Рекурсивно преобразует ключи объекта из camelCase в snake_case
 */
export function transformKeysToSnakeCase<T = any>(obj: any): T {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(transformKeysToSnakeCase) as T
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    const transformed: Record<string, any> = {}
    for (const [key, value] of Object.entries(obj)) {
      const snakeKey = camelToSnake(key)
      transformed[snakeKey] = transformKeysToSnakeCase(value)
    }
    return transformed as T
  }

  return obj
}

/**
 * Рекурсивно преобразует ключи объекта из snake_case в camelCase
 */
export function transformKeysToCamelCase<T = any>(obj: any): T {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(transformKeysToCamelCase) as T
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    const transformed: Record<string, any> = {}
    for (const [key, value] of Object.entries(obj)) {
      const camelKey = snakeToCamel(key)
      transformed[camelKey] = transformKeysToCamelCase(value)
    }
    return transformed as T
  }

  return obj
}


